// 路由配置
export interface RouteConfig {
  path: string;
  component: string;
  requiresAuth: boolean;
  description: string;
}

// 静态路由配置（不依赖数据库的固定路由）
export const staticRoutes: RouteConfig[] = [
  {
    path: "/login",
    component: "LoginPage",
    requiresAuth: false,
    description: "登录页面"
  },
  {
    path: "/redirect",
    component: "ServiceRedirect",
    requiresAuth: false,
    description: "服务跳转页面"
  }
];

// 动态路由配置（从数据库获取的微服务路由）
// 这些路由会在运行时根据数据库中的微服务配置动态生成
export const dynamicRoutes: RouteConfig[] = [
  // 这些路由将由 ServiceContext 根据数据库中的微服务配置动态生成
  // 包括：/services, /msadmin, /msspace 等
];

// 合并所有路由（向后兼容）
export const routes: RouteConfig[] = [...staticRoutes, ...dynamicRoutes];

// 默认路由
export const DEFAULT_ROUTE = "/login";

// 登录路由
export const LOGIN_ROUTE = "/login";

// 需要认证的路由路径
export const AUTHENTICATED_ROUTES = routes
  .filter(route => route.requiresAuth)
  .map(route => route.path);

// 公开路由路径
export const PUBLIC_ROUTES = routes
  .filter(route => !route.requiresAuth)
  .map(route => route.path);

// 根据路径获取路由配置
export const getRouteConfig = (path: string): RouteConfig | undefined => {
  return routes.find(route => route.path === path);
};

// 静态路由的权限检查（不依赖数据库）
export const requiresAuth = (path: string): boolean => {
  // 静态路由的权限配置
  const staticRouteAuth = {
    "/login": false,
    "/redirect": false,
  };

  // 如果是静态路由，直接返回配置
  if (path in staticRouteAuth) {
    return staticRouteAuth[path as keyof typeof staticRouteAuth];
  }

  // 对于动态路由（微服务路由），默认需要认证
  // 具体的权限检查将在 ServiceContext 中处理
  return true;
};
